import React from "react";
import { Card, Badge } from "react-bootstrap";
import { FaUpload, FaRobot } from "react-icons/fa";

const logs = [
  {
    id: 1,
    icon: <FaUpload className="log-icon upload-icon" />,
    title: "Document Uploaded",
    description: `Employee uploaded "PPF_Statement_2024.pdf" for Section 80C (₹1.5L)`,
    actor: "John Smith (Employee)",
    action: "Upload",
    actionColor: "success",
    time: "07 Oct 2025, 2:30 PM",
  },
  {
    id: 2,
    icon: <FaRobot className="log-icon ocr-icon" />,
    title: "OCR Processing Completed",
    description:
      "OCR extracted Section 80C - PPF investment details with 95% confidence",
    actor: "System (OCR Engine)",
    action: "Extract",
    actionColor: "primary",
    time: "07 Oct 2025, 2:32 PM",
  },
];

const AuditTrail = () => {
  return (
    <div className="activity-log-container">
      {logs.map((log) => (
        <div key={log.id} className="activity-log-item d-flex">
          <div className="icon-container">{log.icon}</div>
          <Card className="flex-grow-1 log-card">
            <Card.Body>
              <div className="d-flex justify-content-between align-items-start">
                <div>
                  <Card.Title className="fw-bold text-light mb-1">
                    {log.title}
                  </Card.Title>
                  <Card.Text className="text-secondary mb-2">
                    {log.description}
                  </Card.Text>
                  <Card.Text className="text-gray small d-flex align-items-center gap-3">
                    Actor:{log.actor}{" "}
                    <span style={{width: "80px", height: "30px"}} className={ log.actionColor == "primary" ? "badge-purple" : "badge-green" }>{log.action}</span>
                  </Card.Text>
                </div>
                <small className="text-white">{log.time}</small>
              </div>
            </Card.Body>
          </Card>
        </div>
      ))}
    </div>
  );
};

export default AuditTrail;